import { InputField } from "../types/worksheet";

// Submission type options
export const submissionTypeOptions = [
  { value: "owner", label: "Note Owner" },
  { value: "birddog", label: "A Birddog" },
  { value: "broker", label: "A Broker" },
];

// Submission Type Fields
export const submissionTypeFields: InputField[] = [
  {
    section: "submissionType",
    name: "submissionType",
    label: "I am submitting this note as:",
    type: "radio",
    required: true,
    validation: [
      {
        type: "required",
        message: "Please select who is submitting this note",
      },
    ],
    options: [
      { label: "Note Owner", value: "owner", tooltip: "The owner of the note" },
      { label: "A Birddog", value: "birddog", tooltip: "A birddog" },
      { label: "A Broker", value: "broker", tooltip: "A broker" },
    ],
  },
];

// Owner Info Fields
export const ownerInfoFields: InputField[] = [
  // Owner fields - shown when submissionType is owner
  {
    section: "ownerInfo",
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "First name is required" }],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Last name is required" }],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "email",
    label: "Email",
    type: "email",
    required: true,
    validation: [
      { type: "required", message: "Email is required" },
      { type: "email", message: "Please enter a valid email address" },
    ],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "phone",
    label: "Phone",
    type: "tel",
    required: true,
    validation: [
      { type: "required", message: "Phone number is required" },
      { type: "phone", message: "Please enter a valid phone number" },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 10,
      },
      {
        type: "numeric",
        value: 10,
      },
    ],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "mailingAddress",
    label: "Mailing Address",
    type: "text",
    required: true,
    // fullWidth: true,
    validation: [{ type: "required", message: "Mailing address is required" }],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "city",
    label: "City",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "City is required" }],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "state",
    label: "State",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "State is required" }],
    showWhen: (formData) => formData.submissionType === "owner",
  },
  {
    section: "ownerInfo",
    name: "zipCode",
    label: "Zip Code",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Zip code is required" },
      {
        type: "pattern",
        message: "Please enter a valid 5-digit zip code",
        value: "^\\d{5}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 5,
      },
      {
        type: "numeric",
        value: 5,
      },
    ],
    showWhen: (formData) => formData.submissionType === "owner",
  },

  // Birddog fields - shown when submissionType is birddog
  {
    section: "ownerInfo",
    name: "yourFirstName",
    label: "Your First Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your first name is required" }],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourLastName",
    label: "Your Last Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your last name is required" }],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourEmail",
    label: "Your Email",
    type: "email",
    required: true,
    validation: [
      { type: "required", message: "Your email is required" },
      { type: "email", message: "Please enter a valid email address" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourPhone",
    label: "Your Phone",
    type: "tel",
    required: true,
    validation: [
      { type: "required", message: "Your phone number is required" },
      { type: "phone", message: "Please enter a valid phone number" },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 10,
      },
      {
        type: "numeric",
        value: 10,
      },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourMailingAddress",
    label: "Your Mailing Address",
    type: "text",
    required: true,
    // fullWidth: true,
    validation: [
      { type: "required", message: "Your mailing address is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourCity",
    label: "Your City",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your city is required" }],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourState",
    label: "Your State",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your state is required" }],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "yourZipCode",
    label: "Your Zip Code",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Zip code is required" },
      {
        type: "pattern",
        message: "Please enter a valid 5-digit zip code",
        value: "^\\d{5}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 5,
      },
      {
        type: "numeric",
        value: 5,
      },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },

  // Owner information when birddog is selected
  {
    section: "ownerInfo",
    name: "ownerFirstName",
    label: "Note Owner's First Name",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's first name is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerLastName",
    label: "Note Owner's Last Name",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's last name is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerEmail",
    label: "Note Owner's Email",
    type: "email",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's email is required" },
      { type: "email", message: "Please enter a valid email address" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerPhone",
    label: "Note Owner's Phone",
    type: "tel",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's phone number is required" },
      { type: "phone", message: "Please enter a valid phone number" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerMailingAddress",
    label: "Note Owner's Mailing Address",
    type: "text",
    required: true,
    // fullWidth: true,
    validation: [
      { type: "required", message: "Note Owner's mailing address is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerCity",
    label: "Note Owner's City",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's city is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerState",
    label: "Note Owner's State",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Note Owner's state is required" },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },
  {
    section: "ownerInfo",
    name: "ownerZipCode",
    label: "Note Owner's Zip Code",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Zip code is required" },
      {
        type: "pattern",
        message: "Please enter a valid 5-digit zip code",
        value: "^\\d{5}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 5,
      },
      {
        type: "numeric",
        value: 5,
      },
    ],
    showWhen: (formData) => formData.submissionType === "birddog",
  },

  // Broker fields - shown when submissionType is broker
  {
    section: "ownerInfo",
    name: "yourFirstName",
    label: "Your First Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your first name is required" }],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourLastName",
    label: "Your Last Name",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your last name is required" }],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourEmail",
    label: "Your Email",
    type: "email",
    required: true,
    validation: [
      { type: "required", message: "Your email is required" },
      { type: "email", message: "Please enter a valid email address" },
    ],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourPhone",
    label: "Your Phone",
    type: "tel",
    required: true,
    validation: [
      { type: "required", message: "Your phone number is required" },
      { type: "phone", message: "Please enter a valid phone number" },
    ],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourMailingAddress",
    label: "Your Mailing Address",
    type: "text",
    required: true,
    // fullWidth: true,
    validation: [
      { type: "required", message: "Your mailing address is required" },
    ],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourCity",
    label: "Your City",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your city is required" }],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourState",
    label: "Your State",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "Your state is required" }],
    showWhen: (formData) => formData.submissionType === "broker",
  },
  {
    section: "ownerInfo",
    name: "yourZipCode",
    label: "Your Zip Code",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Zip code is required" },
      {
        type: "pattern",
        message: "Please enter a valid 5-digit zip code",
        value: "^\\d{5}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 5,
      },
      {
        type: "numeric",
        value: 5,
      },
    ],
    showWhen: (formData) => formData.submissionType === "broker",
  },
];

// Property Info Fields
export const propertyInfoFields: InputField[] = [
  {
    section: "propertyInfo",
    name: "propertyAddress",
    label: "Property Address",
    type: "text",
    required: true,
    fullWidth: true,
    validation: [{ type: "required", message: "Property address is required" }],
  },
  {
    section: "propertyInfo",
    name: "city",
    label: "City",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "City is required" }],
  },
  {
    section: "propertyInfo",
    name: "state",
    label: "State",
    type: "text",
    required: true,
    validation: [{ type: "required", message: "State is required" }],
  },
  {
    section: "propertyInfo",
    name: "zipCode",
    label: "Zip Code",
    type: "text",
    required: true,
    validation: [
      { type: "required", message: "Zip code is required" },
      {
        type: "pattern",
        message: "Please enter a valid 5-digit zip code",
        value: "^\\d{5}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 5,
      },
      {
        type: "numeric",
        value: 5,
      },
    ],
  },
  {
    section: "propertyInfo",
    name: "propertyType",
    label: "Type of Property",
    type: "select",
    required: true,
    validation: [{ type: "required", message: "Property type is required" }],
    options: [
      { label: "Single Family Home", value: "Single Family Home" },
      { label: "Condo", value: "Condo" },
      { label: "Townhouse", value: "Townhouse" },
      { label: "2-4 Rental Units", value: "2 to 4 Rental Units" },
      { label: "5+ Rental Units", value: "5+ Rental Units" },
      {
        label: "Double Wide Mobile Home With Land",
        value: "Double Wide Mobile Home With Land",
      },
      {
        label: "Single Wide Mobile Home With Land",
        value: "Single Wide Mobile Home With Land",
      },
      { label: "Improved Residential Lot", value: "Improved Residential Lot" },
      { label: "Improved Land", value: "Improved Land" },
      { label: "Raw Land", value: "Raw Land" },
      { label: "Commercial Property", value: "Commercial Property" },
      {
        label: "Business Only - No Real Estate",
        value: "Business Only - No Real Estate",
      },
      {
        label: "Mobile Home Only - No Land",
        value: "Mobile Home Only - No Land",
      },
      { label: "Other", value: "Other" },
    ],
  },
  {
    section: "propertyInfo",
    name: "yearBuilt",
    label: "Year Property Built",
    type: "number",
    required: true,
    validation: [
      { type: "required", message: "Year built is required" },
      {
        type: "pattern",
        message: "Please enter a valid year (YYYY)",
        value: "^\\d{4}$",
      },
    ],
    coercion: [
      {
        type: "exactLength",
        value: 4,
      },
    ],
    placeholder: "YYYY",
  },
  {
    section: "propertyInfo",
    name: "acreage",
    label: "Acreage",
    type: "select",
    required: true,
    validation: [{ type: "required", message: "Acreage is required" }],
    options: [
      { label: "Less Than .5 Acre", value: "Less Than .5 Acre" },
      { label: ".5 to 1 Acre", value: ".5 to 1 Acre" },
      { label: "1 to 5", value: "1 to 5" },
      { label: "6 to 10", value: "6 to 10" },
      { label: "11 to 20", value: "11 to 20" },
      { label: "More than 20", value: "More than 20" },
    ],
  },
  {
    section: "propertyInfo",
    name: "propertyDescription",
    label: "Property Description",
    type: "textarea",
    required: false,
  },
  {
    section: "propertyInfo",
    name: "occupancy",
    label: "Occupancy",
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "Occupancy is required" }],
    options: [
      { label: "Owner Occupied", value: "Owner Occupied" },
      { label: "Rental", value: "Rental" },
      { label: "Vacant", value: "Vacant" },
    ],
  },
  {
    section: "propertyInfo",
    name: "estimatedValue",
    label: "Current Estimated Value of Property",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Estimated value is required" },
      { type: "minValue", message: "Value must be greater than 0", value: 0 },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
];

// Note Info Fields
export const noteInfoFields: InputField[] = [
  {
    section: "noteInfo",
    name: "noteDate",
    label: "Note Date",
    type: "date",
    required: true,
    validation: [{ type: "required", message: "Note date is required" }],
  },
  {
    section: "noteInfo",
    name: "propertySalePrice",
    label: "Property Sale Price",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Property sale price is required" },
      { type: "minValue", message: "Value must be greater than 0", value: 0 },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
  {
    section: "noteInfo",
    name: "downPaymentAmount",
    label: "Down Payment Amount",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Down payment amount is required" },
      {
        type: "minValue",
        message: "Value must be greater than or equal to 0",
        value: 0,
      },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
  {
    section: "noteInfo",
    name: "originalStartingBalance",
    label: "Original Starting Balance of Note",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Original starting balance is required" },
      { type: "minValue", message: "Value must be greater than 0", value: 0 },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
  {
    section: "noteInfo",
    name: "currentPrincipleBalance",
    label: "Current Principle Balance of Note",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Current principle balance is required" },
      {
        type: "minValue",
        message: "Value must be greater than or equal to 0",
        value: 0,
      },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
  {
    section: "noteInfo",
    name: "interestRate",
    label: "Interest Rate",
    type: "number",
    required: true,
    step: "0.001",
    validation: [
      { type: "required", message: "Interest rate is required" },
      {
        type: "minValue",
        message: "Value must be greater than or equal to 0",
        value: 0,
      },
      {
        type: "pattern",
        message: "Please enter a value with at least 3 decimal places",
        value: "^\\d+(\\.\\d{3,})$",
      },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 4,
      },
    ],
    placeholder: "0.000",
  },
  {
    section: "noteInfo",
    name: "paymentAmount",
    label: "Payment Amount (Principal and Interest Only)",
    type: "number",
    required: true,
    step: "0.01",
    validation: [
      { type: "required", message: "Payment amount is required" },
      { type: "minValue", message: "Value must be greater than 0", value: 0 },
    ],
    coercion: [
      {
        type: "maxDecimals",
        value: 2,
      },
    ],
  },
  {
    section: "noteInfo",
    name: "paymentOptions",
    label: "Payment Options",
    type: "select",
    required: true,
    validation: [{ type: "required", message: "Payment option is required" }],
    options: [
      { label: "Monthly", value: "Monthly" },
      { label: "Weekly", value: "Weekly" },
      { label: "Quarterly", value: "Quarterly" },
      { label: "Semi-Annually", value: "Semi-Annually" },
      { label: "Annually", value: "Annually" },
    ],
  },
  {
    section: "noteInfo",
    name: "nextPaymentDate",
    label: "Next Payment Date",
    type: "date",
    required: true,
    validation: [
      { type: "required", message: "Next payment date is required" },
    ],
  },
  {
    section: "noteInfo",
    name: "maturityDate",
    label: "Maturity Date",
    type: "date",
    required: true,
    validation: [{ type: "required", message: "Maturity date is required" }],
  },
  {
    section: "noteInfo",
    name: "hasBalloonPayment",
    label: 'Is There an "All Due" Or "Balloon Payment" Date?',
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "This field is required" }],
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" },
    ],
  },
  {
    section: "noteInfo",
    name: "balloonPaymentDate",
    label: "Balloon Payment Date",
    type: "date",
    required: (formData: any) => formData.noteInfo.hasBalloonPayment === "true",
    validation: (formData: any) =>
      formData.noteInfo.hasBalloonPayment === "true"
        ? [{ type: "required", message: "Balloon payment date is required" }]
        : [],
    showWhen: (formData) => formData.noteInfo.hasBalloonPayment === "true",
  },
  {
    section: "noteInfo",
    name: "paymentsCurrent",
    label: "Are Payments Current?",
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "This field is required" }],
    options: [
      { label: "Yes - Current", value: "true" },
      { label: "No - Delinquent", value: "false" },
    ],
  },
  {
    section: "noteInfo",
    name: "totalDebt",
    label:
      "What is the current TOTAL debt including all principal, interest payments, late charges & accelerated interest?",
    type: "number",
    required: (formData: any) => formData.noteInfo.paymentsCurrent === "false",
    validation: (formData: any) =>
      formData.noteInfo.paymentsCurrent === "false"
        ? [{ type: "required", message: "Total debt is required" }]
        : [],
    showWhen: (formData) => formData.noteInfo.paymentsCurrent === "false",
  },
  {
    section: "noteInfo",
    name: "paymentCollector",
    label: "Who Collects Payments",
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "This field is required" }],
    options: [
      {
        label: "Seller Collects Directly From Buyer/Payer",
        value: "Seller Collects Directly From Buyer/Payer",
      },
      { label: "Third Party Servicer", value: "Third Party Servicer" },
    ],
  },
  {
    section: "noteInfo",
    name: "thirdPartyServicerName",
    label: "Name of Third Party Service",
    type: "text",
    required: (formData: any) =>
      formData.noteInfo.paymentCollector === "Third Party Servicer",
    validation: (formData: any) =>
      formData.noteInfo.paymentCollector === "Third Party Servicer"
        ? [
            {
              type: "required",
              message: "Third party servicer name is required",
            },
          ]
        : [],
    showWhen: (formData) =>
      formData.noteInfo.paymentCollector === "Third Party Servicer",
  },
  {
    section: "noteInfo",
    name: "isFirstPosition",
    label: "Is This A First Position Note?",
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "This field is required" }],
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" },
    ],
  },
  {
    section: "noteInfo",
    name: "noteAskingPrice",
    label: "Note Asking Price",
    type: "number",
    required: true,
    validation: [
      { type: "required", message: "Note asking price is required" },
      { type: "minValue", message: "Value must be at least 1", value: 1 },
    ],
  },
  {
    section: "noteInfo",
    name: "specialCircumstances",
    label:
      "Please Let Us Know Any Special Circumstances or Reasons for Selling the Note",
    type: "textarea",
    required: false,
  },
  {
    section: "noteInfo",
    name: "documents",
    label: "Upload Documents (Multiple Files Allowed)",
    type: "file",
    required: false,
  },
  {
    section: "noteInfo",
    name: "documentSubmissionType",
    label: "Are You Providing Copies of Documents At This Time?",
    type: "radio",
    required: true,
    validation: [{ type: "required", message: "This field is required" }],
    options: [
      {
        label: "Yes - Copies Included in Attached Upload",
        value: "Yes - Copies Included in Attached Upload",
      },
      {
        label: "No - Documents Will Follow At A Later Date",
        value: "No - Documents Will Follow At A Later Date",
      },
    ],
  },
  {
    section: "noteInfo",
    name: "additionalComments",
    label: "Additional Comments",
    type: "textarea",
    required: false,
  },
];

// Combine all fields
export const noteWorksheetInputs = {
  ownerInfo: ownerInfoFields,
  propertyInfo: propertyInfoFields,
  noteInfo: noteInfoFields,
};
